define('xml', function () {
    return {
        load: function (name, require, onload, config) {
            Cortona3DSolo.app.util.loadResource(require.toUrl(name), 'text/xml')
                .then(function (xhr) {
                    if (xhr.responseXML) {
                        onload(xhr.responseXML);
                    } else {
                        throw new Error(url + " empty content");
                    }
                })
                .catch(onload.error);
        }
    };
});